import { Table, TableBody } from "@mui/material";
import { useMemo } from "react";

import { type RoleEntity } from "@/modules/roles/types";

import { SimpleBoxLoader } from "../loader";

import { ROLES_TABLE_DATA_COLUMNS } from "./constants";
import { RolesTableHead } from "./RolesTableHead";
import { type EntityRulesCheckMap, RolesTableRow } from "./RolesTableRow";

interface RolesTableProps {
  entities: RoleEntity[];
  rules: string[];
  isDisabled?: boolean;
  isLoading?: boolean;
  onChange?: (ruleToChange: string, isChecked: boolean) => void;
}

export const RolesTable = ({
  entities,
  rules,
  isDisabled,
  isLoading,
  onChange,
}: RolesTableProps) => {
  const ruleSet = useMemo(() => new Set(rules), [rules]);

  if (isLoading) {
    return <SimpleBoxLoader />;
  }

  return (
    <Table>
      <RolesTableHead />
      <TableBody>
        {entities.map((entity) => {
          const checkMap = ROLES_TABLE_DATA_COLUMNS.reduce((map, column) => {
            map[column] = ruleSet.has(entity.rules[column] as string);

            return map;
          }, {} as EntityRulesCheckMap);

          return (
            <RolesTableRow
              key={entity.name}
              entity={entity}
              isDisabled={isDisabled}
              onChange={onChange}
              {...checkMap}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};
